import {CTMSMetadata, DataObject, Keywords, PostObject, PostObjectResponse} from "./metadata";
import { StrategicPillar } from "../services/strategic-pillar.service";
import { VeevaTaggedAudience } from "../services/audience.service";

export class CTMSMilestone extends DataObject{
  metadata!: CTMSMetadata
  keyWords!: Keywords
  link!: string
  notes!: string
  isVisible!: boolean
  
  // Update to match API response format
  strategicPillars: StrategicPillar[] = [];
  // Audiences tagged to the milestone (from Veeva)
  audiences: VeevaTaggedAudience[] = [];

  get abstractID(): string {
    return this.metadata.cmID;
  }

  get abstractDate(): string{
    return this.metadata.date
  }

  toPost(changes: CTMSMilestone): CTMSMilestonePost {
    return new CTMSMilestonePost(this, changes);
  }

  static override  parseFromPostResponse(post: CTMSMilestonePostResponse): CTMSMilestonePostResponse {
    if (post.updatedData) {
      if ((post.updatedData as any).strategicPillars) {
        (post.updatedData as any).strategicPillars = (post.updatedData as any).strategicPillars.map((p: any) => Object.assign({}, p));
      }
      if ((post.updatedData as any).audiences) {
        (post.updatedData as any).audiences = (post.updatedData as any).audiences.map((a: any) => Object.assign({}, a));
      }
    }
    post.updatedData = Object.assign(new CTMSMilestone(), post.updatedData);
    return post
  }
  
  // Helper getter to maintain backward compatibility with existing code
  get strategicPillar(): StrategicPillar | undefined {
    return this.strategicPillars && this.strategicPillars.length > 0 ? this.strategicPillars[0] : undefined;
  }
}

export interface CTMSMilestoneEndpointResponse {
    isOld: boolean,
    lastUpdate: string,
    ctmsMilestones: Array<CTMSMilestone>
}

export interface DataRefreshResponse {
  status?: number,
  error?: string,
}

export interface SyncAllResponse {
  success: boolean;
  message: string;
  triggeredBy: string;
  timestamp: string;
  results: {
    publications: { success: boolean; error: string | null; result: any };
    ctms: { success: boolean; error: string | null; result: any };
  };
}

export type SyncSource = 'publications' | 'ctms' | 'congress' | 'veeva';

export const SYNC_SOURCE_LABELS: Record<SyncSource, string> = {
  publications: 'Publications',
  ctms: 'Milestones',
  congress: 'Congresses',
  veeva: 'VVPM',
};

export interface SyncSingleResponse {
  success: boolean;
  message?: string;
  error?: string | null;
}

export const TEST_MILESTONE: CTMSMilestone = Object.assign(new CTMSMilestone(), {
  "metadata": {
    "cmID": "Milestone ID",
    "projectName": "Project Name",
    "activityName": "Activity Name",
    "studyDescription": "Study Description",
    "date": new Date("Tue Mar 07 2023 ").toISOString().split("T")[0]
  },
  "keyWords": [
    "Keyword 1",
    "Keyword 2",
    "keyword 3",
    "Keyword 4"
  ],
  "link": "http://linkX.com",
  "notes": "Notes. This can be a looooong text",
  "isVisible": true,
} as CTMSMilestone)

export class CTMSMilestonePost extends PostObject{
  cmID!: string
  link!: string
  notes!: string
  isVisible!: boolean
  strategicPillars?: number[]
  audiences?: number[]

  constructor(source: CTMSMilestone, newValue: CTMSMilestone) {
    super(source, newValue);
    if(source.metadata.cmID !== newValue.metadata.cmID){
      throw Error("CTMSMilestonePost: cmID cannot be overwritten");
    }
    this.cmID = newValue.metadata.cmID
    this.link = newValue.link
    this.notes = newValue.notes
    this.isVisible = newValue.isVisible
  }

  getSourceWrapper(): {(post: CTMSMilestonePostResponse): CTMSMilestonePostResponse} {
    return CTMSMilestone.parseFromPostResponse
  }
}

export type CTMSMilestonePostResponse = PostObjectResponse<CTMSMilestone>
